function HotSpotEdit(hs) {
    this.hs = hs;
    this.node = hs.node;

	var self = this;
//    this.playernode = $("#player");
    this.playernode = $("body");
//	this.node.on(Events.pointer.down, function(evt) {var pe = Events.getPointerEvent(evt); self.mouseDown(pe);});
    this.node.on("click", function(evt) {var pe = Events.getPointerEvent(evt); self.click(pe);});

 
//    this.addSprite();
}

HotSpotEdit.prototype.addUI = function() {
//   this.mover = $("<div class='hs_mover'><i class='fa fa-arrows-alt'></i></div>");
   if (this.mover == undefined) {
        this.mover = $("<div class='hs_mover'></div>");
   }

   this.mover.on(Events.pointer.down, function(evt) {var pe = Events.getPointerEvent(evt); self.mouseDown(pe);});
   
   this.hs.node.append(this.mover);
}

HotSpotEdit.prototype.addSprite = function() {
    var self = this;
    /*
    var texture = new THREE.TextureLoader().load( "http://wkraj.pl/html5/assets/uploading.png", function (texture) {
        texture.magFilter = THREE.NearestFilter;
        texture.minFilter = THREE.NearestFilter;
        texture.generateMipmaps = false;

        var material = new THREE.MeshBasicMaterial( {color: 0xffffff, map: texture} );

        material.side = THREE.DoubleSide;

        self.sprite = new THREE.Sprite(material);
        self.sprite.visible = true;
        self.sprite.position.x = 0;//this.hs.vec3D.x;
        self.sprite.position.y = 0;//this.hs.vec3D.y;
        self.sprite.position.z = -40;//this.hs.vec3D.z;
        //this.sprite.scale.x = 14;
        //this.sprite.scale.y = 14;
        //this.sprite.scale.z = 14;
        self.sprite.layers.set(sphereWebGLStatic.cycle);
        sphereWebGLStatic.scene.add( self.sprite );
        console.log("sprite added");
        console.log(sphereWebGLStatic.cycle);
    } );
    */
    
    var geometry = new THREE.BoxGeometry( 1, 1, 1 );
    var material = new THREE.MeshBasicMaterial( {color: 0x00ff00} );
    this.helper = new THREE.Mesh( geometry, material );        
    this.helper.position.x = this.hs.vec3D.x;
    this.helper.position.y = this.hs.vec3D.y;
    this.helper.position.z = this.hs.vec3D.z;
//    this.helper.layers.set(sphereWebGLStatic.cycle);
    this.helper.layers.set(0);
    sphereWebGLStatic.scene.add( this.helper );    
}

HotSpotEdit.prototype.update = function() {
	var tvector = new THREE.Vector3();
    var vector = new THREE.Vector3();

    var widthHalf = 0.5 * this.manager.player.renderer.context.canvas.width;
    var heightHalf = 0.5 * this.manager.player.renderer.context.canvas.height;

    this.sprite.updateMatrixWorld();
    vector.setFromMatrixPosition(this.sprite.matrixWorld);
    tvector.setFromMatrixPosition(this.sprite.matrixWorld.premultiply(this.manager.player.camera.matrixWorldInverse));

    //$(".panel-title").html("X:" + tvector.x + "; Y:" + tvector.y + "; Z:" + tvector.z);

    if (tvector.z < 0) {

        vector.project(this.manager.player.camera);

        vector.x = ( vector.x * widthHalf ) + widthHalf;
        vector.y = - ( vector.y * heightHalf ) + heightHalf;

        if (!this.dragging) {
        	this.node.css("left", vector.x - this.node.width() * 0.5);
        	this.node.css("top", vector.y - this.node.height() * 0.5);
    	}

        return { 
            x: vector.x,
            y: vector.y
        };
    } else {
        return { 
            x: -50,
            y: -50
        };        
    }

}

HotSpotEdit.prototype.click = function(event) {
    self = this;

    $(".hs_mover").hide();
    this.mover.show();
    SpotEdit.select(this);
}

HotSpotEdit.prototype.mouseDown = function(event) {
	this.drag = {};
	this.drag.x = event.pageX;
	this.drag.y = event.pageY;
	this.down = true;

    self = this;
    this.playernode.one(Events.pointer.up, function(evt) {var pe = Events.getPointerEvent(evt); self.mouseUp(pe);});
    this.playernode.on(Events.pointer.move, function(evt) {var pe = Events.getPointerEvent(evt);self.mouseMove(pe);});

//    console.log("mouse down");

    this.node.css("pointer-events", "none");

    this.hs.updatePosition = false;

    SpotEdit.select(this);

    event.origin.preventDefault();
}

HotSpotEdit.prototype.moveToScreenCoords = function(sx, sy) {
    var m4t = new THREE.Matrix4();
    var m4r = new THREE.Matrix4();

    if (this.hs.node3D != undefined) {
        var l = this.hs.node3D.last;
        var xx = sx;// + this.node.outerWidth() * 0.5;
        var yy = sy;// + this.node.outerHeight() * 0.5;

        this.hs.node3D.resetTransform();
        this.hs.node3D.translate(xx, yy, 0);
        this.hs.node3D.applyTransforms();

        var raycaster = new THREE.Raycaster();
        var mouse = new THREE.Vector2();
        mouse.x = ( xx / this.playernode.width()) * 2 - 1;
        mouse.y = - ( yy / this.playernode.height()) * 2 + 1;

//        player.currentView.renderer.camera.layers.set(1);
//        player.currentView.renderer.preview.layers.set(1);

        raycaster.layers.enableAll();
        raycaster.setFromCamera( mouse, player.currentView.renderer.camera );

        var objects = [];
//        var intersects = raycaster.intersectObject( player.currentView.renderer.preview, false);
        var intersects = raycaster.intersectObject( player.currentView.renderer.preview, true);

//        console.log(player.currentView.renderer.camera);
//        console.log(player.currentView.renderer.preview);
//        console.log(intersects);

        /*
        this.helper.position.x = intersects[0].point.x;
        this.helper.position.y = intersects[0].point.y;
        this.helper.position.z = intersects[0].point.z;
        */

        //var v4 = intersects[0].point;
        var v4 = new THREE.Vector4();
        v4.fromArray([intersects[0].point.x, intersects[0].point.y, intersects[0].point.z, 0]);
        //m4t.extractRotation(player.currentView.renderer.preview.matrixWorld);
        
        m4r.makeRotationY((360 - (player.currentView.renderer.jaw * 180 / Math.PI)) * Math.PI / 180);
        m4t.makeRotationX(player.currentView.renderer.pitch * -1);
        m4r.multiply(m4t);

        v4 = v4.applyMatrix4(m4r);

        this.hs.vec3D.x = v4.x;
        this.hs.vec3D.y = v4.y;
        this.hs.vec3D.z = v4.z;

        // calculations for angles
        v4.fromArray([intersects[0].point.x, intersects[0].point.y, intersects[0].point.z, 0]);

        m4r.makeRotationY((360 - (player.currentView.renderer.jaw * 180 / Math.PI)) * Math.PI / 180);
        m4t.makeRotationX(player.currentView.renderer.pitch * -1);
        m4r.multiply(m4t);

        v4 = v4.applyMatrix4(m4r);

        var q = new THREE.Quaternion();
        var v3 = new THREE.Vector3(v4.x, v4.y, v4.z);
        q.setFromUnitVectors( new THREE.Vector3( 0, 0, -1 ), v3.normalize());
        var euler = new THREE.Euler().setFromQuaternion( q, 'YXZ' );

        var north = parseFloat(player.currentView.properties.properties.north);

        //  - 5

        if (window.currentSpot != null) {
            window.currentSpot.newcoords = true;
            window.currentSpot.x = (((360 + north) - Math.round((euler.y * 180 / Math.PI) * 100) * 0.01 + 180) % 360);
            window.currentSpot.y = Math.round((euler.x * 180 / Math.PI) * 100) * -0.01;
        }

        SpotEdit.updateCoords((((360 + north) - Math.round((euler.y * 180 / Math.PI) * 100) * 0.01 + 180) % 360), Math.round((euler.x * 180 / Math.PI) * 100) * -0.01);
    
    } else if (this.hs.node != undefined) {

        this.hs.properties.x = (sx / player._width) * 1000;
        this.hs.properties.y = (sy / player._height) * 500;
        
        console.log(sx);
    }
}

HotSpotEdit.prototype.mouseUp = function(event) {
    var m4t = new THREE.Matrix4();
    var m4r = new THREE.Matrix4();

//    console.log("mouse up");

    self = this;
    //this.manager.player.node.off(Events.pointer.up, function(evt) {var pe = Events.getPointerEvent(evt); self.mouseUp(pe);});
    this.playernode.off(Events.pointer.move, function(evt) {var pe = Events.getPointerEvent(evt);self.mouseMove(pe);});
    this.node.css("pointer-events", "all");
    this.hs.updatePosition = true;

    if (this.dragging) {
        this.down = false;
    	this.dragging = false;
//        this.node.css("left", parseInt(this.node.css("left")) + event.pageX - this.drag.x);
//        this.node.css("top", parseInt(this.node.css("top")) + event.pageY - this.drag.y);

        /*
        var xx = event.pageX - this.player.position.left;
        var yy = event.pageY - this.player.position.top;

        var xx = parseInt(this.node.css("left")) + event.pageX - this.drag.x + this.node.width() * 0.5;
        var yy = parseInt(this.node.css("top")) + event.pageY - this.drag.y + this.node.height() * 0.5;
        */

        var l;
        if (this.hs.node3D != undefined) {
            l = this.hs.node3D.last;

            if (l != undefined) {
                var xx = l.x + event.pageX - this.drag.x;// + this.node.outerWidth() * 0.5;
                var yy = l.y + event.pageY - this.drag.y;// + this.node.outerHeight() * 0.5;

                this.moveToScreenCoords(xx, yy)
            }
        }
        
        /*


        this.hs.node3D.resetTransform();
        this.hs.node3D.translate(xx, yy, 0);
        this.hs.node3D.applyTransforms();

        var raycaster = new THREE.Raycaster();
        var mouse = new THREE.Vector2();
        mouse.x = ( xx / this.playernode.width()) * 2 - 1;
        mouse.y = - ( yy / this.playernode.height()) * 2 + 1;

    	raycaster.setFromCamera( mouse, player.currentView.renderer.camera );

    	var objects = [];
    	var intersects = raycaster.intersectObject( player.currentView.renderer.preview, false);

        var v4 = new THREE.Vector4();
        v4.fromArray([intersects[0].point.x, intersects[0].point.y, intersects[0].point.z, 0]);
        
        m4r.makeRotationY((360 - (player.currentView.renderer.jaw * 180 / Math.PI)) * Math.PI / 180);
        m4t.makeRotationX(player.currentView.renderer.pitch * -1);
        m4r.multiply(m4t);

        v4 = v4.applyMatrix4(m4r);

        this.hs.vec3D.x = v4.x;
        this.hs.vec3D.y = v4.y;
        this.hs.vec3D.z = v4.z;

        v4.fromArray([intersects[0].point.x, intersects[0].point.y, intersects[0].point.z, 0]);

        m4r.makeRotationY((360 - (player.currentView.renderer.jaw * 180 / Math.PI)) * Math.PI / 180);
        m4t.makeRotationX(player.currentView.renderer.pitch * -1);
        m4r.multiply(m4t);

        v4 = v4.applyMatrix4(m4r);

        var q = new THREE.Quaternion();
        var v3 = new THREE.Vector3(v4.x, v4.y, v4.z);
        q.setFromUnitVectors( new THREE.Vector3( 0, 0, -1 ), v3.normalize());
        var euler = new THREE.Euler().setFromQuaternion( q, 'YXZ' );

        var north = parseFloat(player.currentView.properties.properties.north);

        if (window.currentSpot != null) {
            window.currentSpot.newcoords = true;
            window.currentSpot.x = (((360 + north) - Math.round((euler.y * 180 / Math.PI) * 100) * 0.01 + 180) % 360);
            window.currentSpot.y = Math.round((euler.x * 180 / Math.PI) * 100) * -0.01;
        }

        SpotEdit.updateCoords((((360 + north) - Math.round((euler.y * 180 / Math.PI) * 100) * 0.01 + 180) % 360), Math.round((euler.x * 180 / Math.PI) * 100) * -0.01);
        */
    } else {
        this.down = false;
        this.dragging = false;

        //this.manager.action(this);
    }
	
    event.origin.preventDefault();
}

HotSpotEdit.prototype.mouseMove = function(event) {
	if (this.down) {
        //console.log("mouse move");

        this.dragging = true;
        /*
	    this.node.css("left", parseInt(this.node.css("left")) + event.pageX - this.drag.x);
	    this.node.css("top", parseInt(this.node.css("top")) + event.pageY - this.drag.y);
        */
        
        if (this.hs.node3D != undefined) {
            var l = this.hs.node3D.last;
            this.hs.node3D.resetTransform();
            this.hs.node3D.translate(l.x + event.pageX - this.drag.x, l.y + event.pageY - this.drag.y, 0);
            this.hs.node3D.applyTransforms();
        } else {
            var cx = (event.pageX - this.drag.x);
            var cy = (event.pageY - this.drag.y);

            this.hs.properties.x += (cx / player._width) * 1000;
            this.hs.properties.y += (cy / player._height) * 500;
        }

		this.drag.x = event.pageX;
		this.drag.y = event.pageY;
	}

    event.origin.preventDefault();
}

HotSpotEdit.prototype.center = function() {
    var raycaster = new THREE.Raycaster();
    var mouse = new THREE.Vector2();
    mouse.x = 0;
    mouse.y = 0;

    raycaster.setFromCamera( mouse, this.manager.player.camera );

    var objects = [];
    var intersects = raycaster.intersectObject( this.manager.player.geometry, false);   

    //console.log(event.origin);

    //console.log(mouse);

    //console.log(intersects[0].point);
    //console.log(this.sprite.position);
    
    this.sprite.position.x = intersects[0].point.x;
    this.sprite.position.y = intersects[0].point.y;
    this.sprite.position.z = intersects[0].point.z;
}